export default __webpack_public_path__ + "static/media/768.8b51c98c.gif";